import { render } from "./Group.vue?vue&type=template&id=826421ee&scoped=true"
import script from "./Group.vue?vue&type=script&lang=js"
export * from "./Group.vue?vue&type=script&lang=js"

import "./Group.vue?vue&type=style&index=0&id=826421ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-826421ee"]])

export default __exports__